(function () {
  // Drives sections/pr-rose-video.liquid.
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Visitors who asked for reduced motion get the poster frame instead.
  if (reduceMotion) {
    document.querySelectorAll("[data-pr-rose-video]").forEach(function (v) {
      v.removeAttribute("autoplay");
      v.pause();
    });
  }

  // Length of pr-rose-video-field.mp3 as cut (23.3439 s): birdsong, crickets
  // about 12 dB under it, and one bee flying past at 9 s (all Pixabay, free
  // to use). Tor's rose-field recording and the bee swarm are gone: its
  // insects were cicadas, not crickets, and the swarm droned (27 Oct 2026).
  // Each layer's end is crossfaded into its start so the mix loops without
  // a seam. Played through Web
  // Audio rather than <audio loop>: every browser leaves a short silence at
  // an MP3's loop point (encoder padding), which is plain to hear under a
  // constant cricket chorus. Decoders that do not strip the padding keep the
  // encoder delay (1105 samples for LAME) at the start, so the loop skips it.
  var LOOP_SECONDS = 23.3439;
  var ENCODER_DELAY = 1105;

  // How many visitors actually listen (Tor, 30 Oct 2026): rose_video.sound_on
  // on a tap, rose_video.sound_off with how long it played, through
  // Shopify.analytics.publish -> Social Ocean pixel -> PostHog like the
  // shop_now.* events. `page` is the template, so the homepage, the Science
  // page and each product page can be told apart.
  function publish(name, properties) {
    var shopify = window.Shopify;
    if (!(shopify && shopify.analytics && shopify.analytics.publish)) return;
    var template = document.body.className.match(/template-([\w-]+)/);
    var product = window.location.pathname.match(/\/products\/([^/?#]+)/);
    properties.page = (template ? template[1] : "") + (product ? ":" + product[1] : "");
    try {
      shopify.analytics.publish(name, { url: window.location.href, properties: properties });
    } catch (err) {}
  }

  document.querySelectorAll("[data-pr-rose-sound]").forEach(function (button) {
    var media = button.parentNode;
    var ctx, gain, source, buffer, loading, on = false, onAt = 0;

    function set(state, method) {
      if (state && !on) {
        onAt = Date.now();
        publish("rose_video.sound_on", {});
      } else if (!state && on) {
        publish("rose_video.sound_off", { method: method, listen_ms: Date.now() - onAt });
      }
      on = state;
      button.setAttribute("aria-pressed", on ? "true" : "false");
    }

    function load() {
      if (!loading) {
        loading = fetch(button.getAttribute("data-src"))
          .then(function (r) { return r.arrayBuffer(); })
          .then(function (data) {
            return new Promise(function (resolve, reject) {
              // Callback form: Safari before 14.1 has no promise version.
              ctx.decodeAudioData(data, resolve, reject);
            });
          })
          .then(function (b) { buffer = b; });
      }
      return loading;
    }

    function start() {
      source = ctx.createBufferSource();
      source.buffer = buffer;
      source.loop = true;
      var padded = buffer.duration - LOOP_SECONDS > 0.01;
      source.loopStart = padded ? ENCODER_DELAY / buffer.sampleRate : 0;
      source.loopEnd = source.loopStart + Math.min(LOOP_SECONDS, buffer.duration);
      source.connect(gain);
      // A short fade in, so the crickets arrive rather than switch on.
      gain.gain.cancelScheduledValues(ctx.currentTime);
      gain.gain.setValueAtTime(0, ctx.currentTime);
      gain.gain.linearRampToValueAtTime(1, ctx.currentTime + 0.6);
      source.start(0, source.loopStart);
    }

    function stop() {
      if (!source) return;
      var s = source;
      source = null;
      gain.gain.cancelScheduledValues(ctx.currentTime);
      gain.gain.setValueAtTime(gain.gain.value, ctx.currentTime);
      gain.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.25);
      s.stop(ctx.currentTime + 0.3);
    }

    button.addEventListener("click", function () {
      button.classList.add("is-used");
      if (on) {
        stop();
        set(false, "tap");
        return;
      }
      if (!ctx) {
        var Ctx = window.AudioContext || window.webkitAudioContext;
        ctx = new Ctx();
        gain = ctx.createGain();
        gain.connect(ctx.destination);
        // iPhones silence Web Audio when the ring switch is on silent, unlike
        // video sound; "playback" makes it behave like a video (Safari 16.4+).
        if (navigator.audioSession) navigator.audioSession.type = "playback";
      }
      set(true);
      // resume() must run inside the tap, before any await, or iOS keeps the
      // context suspended.
      ctx.resume();
      load().then(function () {
        if (on && !source) start();
      }, function () { set(false, "error"); });
    });

    // Stop the sound once the section is scrolled away, so it does not
    // follow the visitor down the page; another tap brings it back.
    new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting && on) {
        stop();
        set(false, "scroll");
      }
    }).observe(media);
  });
})();
